export enum ResponseType {
	Success,
	Fail,
}
